import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient.ts';

const SetPasswordPage: React.FC = () => {
  const [newPass, setNewPass] = useState('');
  const [stage,   setStage]   = useState<'loading' | 'form' | 'done' | 'error'>('loading');
  const [msg,     setMsg]     = useState('');
  const nav = useNavigate();

  /* 1️⃣  establish a session from URL token / code */
  useEffect(() => {
    (async () => {
      // ----- hash style (#access_token=…)
      if (window.location.hash.includes('access_token')) {
        const params = new URLSearchParams(window.location.hash.slice(1));
        const access_token  = params.get('access_token');
        const refresh_token = params.get('refresh_token');
        if (access_token && refresh_token) {
          const { error } = await supabase.auth.setSession({ access_token, refresh_token });
          if (error) { setStage('error'); setMsg(error.message); return; }
          setStage('form');
          return;
        }
      }

      // ----- query-string style (?code=…)
      if (window.location.search.includes('code=')) {
        const code = new URLSearchParams(window.location.search).get('code');
        if (code) {
          const { error } = await supabase.auth.exchangeCodeForSession(code);
          if (error) { setStage('error'); setMsg(error.message); return; }
          setStage('form');
          return;
        }
      }

      // neither present
      setStage('error');
      setMsg('Invalid or expired password-reset link.');
    })();
  }, []);

  /* 2️⃣  submit new password */
  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!newPass || newPass.length < 6) { setMsg('Password must be at least 6 characters.'); return; }
    setStage('loading');
    const { error } = await supabase.auth.updateUser({ password: newPass });
    if (error) { setStage('error'); setMsg(error.message); return; }
    setStage('done');
    setTimeout(() => nav('/profile'), 1500);
  };

  /* 3️⃣  render */
  if (stage === 'loading') return <p style={center}>Verifying link…</p>;
  if (stage === 'error')   return <p style={{ ...center, color:'#dc2626' }}>{msg}</p>;
  if (stage === 'done')    return <p style={{ ...center, color:'#16a34a' }}>Password updated! Redirecting…</p>;

  return (
    <div style={wrap}>
      <form onSubmit={handleSave} style={card}>
        <h2 style={{ marginTop:0 }}>Set a new password</h2>
        {msg && <p style={{ color:'#dc2626', marginTop:0 }}>{msg}</p>}

        <input
          type="password"
          value={newPass}
          onChange={e=>setNewPass(e.target.value)}
          placeholder="New password"
          style={input}
          required
        />

        <button type="submit" style={btn}>Save password</button>
      </form>
    </div>
  );
};

/* ——— tiny inline styles ——— */
const wrap  : React.CSSProperties = { display:'flex', justifyContent:'center', alignItems:'center', minHeight:'100vh', fontFamily:'Inter,sans-serif' };
const card  : React.CSSProperties = { padding:'2rem', border:'1px solid #e2e8f0', borderRadius:10, background:'#fff', boxShadow:'0 4px 8px rgba(0,0,0,0.05)', width:320 };
const input : React.CSSProperties = { width:'100%', padding:'0.75rem', border:'1px solid #cbd5e1', borderRadius:6, marginTop:'1rem' };
const btn   : React.CSSProperties = { marginTop:'1rem', width:'100%', padding:'0.75rem', border:'none', borderRadius:6, background:'#2563eb', color:'#fff', fontWeight:600, cursor:'pointer' };
const center: React.CSSProperties = { textAlign:'center', marginTop:'2rem', fontFamily:'Inter,sans-serif' };

export default SetPasswordPage;
